<p-toast key="tst"></p-toast>

<div class="public-page">
    <div class="approval-detail narrow">
        <div class="public-brand">
            <img src="assets/logos/logo.png" alt="" />
            Comunidad Avalanz
        </div>

        <div *ngIf="loading" class="flex justify-content-center align-items-center py-8">
            <p-progressSpinner strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        </div>

        <!-- Enlace inválido -->
        <section *ngIf="!loading && error" class="panel state-panel" data-tone="rejected">
            <p class="status-line"><span class="status-dot"></span>Enlace no válido</p>
            <h1 class="detail-title">No pudimos abrir la solicitud</h1>
            <p>{{ error }}</p>
            <p>Esto puede deberse a que:</p>
            <ul>
                <li>El enlace expiró</li>
                <li>El enlace ya se utilizó</li>
                <li>El enlace no es válido</li>
            </ul>
        </section>

        <!-- Enlace válido pero ya utilizado: no se carga la solicitud -->
        <section *ngIf="!loading && success && linkDetails?.used && !selectedRequest" class="panel state-panel" data-tone="draft">
            <p class="status-line"><span class="status-dot"></span>Enlace utilizado</p>
            <h1 class="detail-title">Esta solicitud ya fue atendida</h1>
            <p>El enlace de autorización es de un solo uso. Si necesitas revisar la solicitud, entra a Comunidad Avalanz.</p>
        </section>

        <ng-container *ngIf="!loading && success && selectedRequest as request">
            <app-link-expiration
                *ngIf="expirationDate"
                [expirationDate]="expirationDate"
                (expirationStatusChanged)="onExpirationStatusChanged($event)"></app-link-expiration>

            <section class="panel" [attr.data-tone]="getStatusTone(request.status)">
                <p class="status-line">
                    <span class="status-dot"></span>{{ getStatusLabel(request.status) }}
                    <span *ngIf="canApprove(request) && !linkExpired" class="status-note">· requiere tu aprobación</span>
                </p>
                <h1 class="detail-title mb-4">Solicitud de vacaciones</h1>

                <div class="person-head">
                    <p-avatar
                        shape="circle"
                        size="large"
                        [image]="request.user?.photoProfileUrl || undefined"
                        [label]="request.user?.photoProfileUrl ? undefined : initials(fullName(request.user))"></p-avatar>
                    <div class="min-w-0">
                        <div class="person-head-name">{{ fullName(request.user) }}</div>
                        <div class="person-head-meta" *ngIf="request.user?.email">{{ request.user?.email }}</div>
                    </div>
                </div>

                <dl class="facts">
                    <div class="fact-row">
                        <dt>Días solicitados</dt>
                        <dd class="value-primary">{{ request.totalDays }}</dd>
                    </div>
                    <div class="fact-row" *ngIf="request.startDate && request.endDate">
                        <dt>Periodo</dt>
                        <dd>{{ formatDate(request.startDate) }} al {{ formatDate(request.endDate) }}</dd>
                    </div>
                    <div class="fact-row" *ngIf="request.createdOn || request.createdAt">
                        <dt>Fecha de solicitud</dt>
                        <dd>{{ formatDate(request.createdOn || request.createdAt) }}</dd>
                    </div>
                    <div class="fact-row" *ngIf="request.approverBoss">
                        <dt>Jefe que aprueba</dt>
                        <dd>{{ fullName(request.approverBoss) }}</dd>
                    </div>
                </dl>

                <!-- Fechas seleccionadas -->
                <div class="panel-section" *ngIf="request.selectedDates?.length">
                    <p class="text-block-label">Días seleccionados</p>
                    <ul class="date-chips primary">
                        <li *ngFor="let date of request.selectedDates">{{ formatDate(date) }}</li>
                    </ul>
                </div>

                <!-- Adelanto: el jefe debe ver los días y el motivo antes de autorizar -->
                <div *ngIf="request.isAdvance" class="notice" data-tone="review">
                    <i class="pi pi-exclamation-triangle"></i>
                    <div>
                        <p class="notice-title">
                            Adelanto de {{ getAdvanceDays(request) }} día{{ getAdvanceDays(request) === 1 ? '' : 's' }}
                            a cuenta del próximo periodo
                        </p>
                        <p>Motivo: {{ request.advanceReason || 'sin especificar' }}</p>
                    </div>
                </div>

                <div class="panel-section" *ngIf="request.employeeComments">
                    <p class="text-block-label">Comentarios del colaborador</p>
                    <p class="quote">{{ request.employeeComments }}</p>
                </div>

                <div class="panel-section" *ngIf="request.status === 'approved_by_boss' && request.bossComments">
                    <p class="text-block-label">Comentarios del jefe</p>
                    <p class="quote">{{ request.bossComments }}</p>
                </div>

                <div class="panel-section" *ngIf="request.approverComments">
                    <p class="text-block-label">Comentarios del aprobador</p>
                    <p class="quote">{{ request.approverComments }}</p>
                </div>

                <div *ngIf="request.rejectionReason" class="notice" data-tone="rejected">
                    <i class="pi pi-times-circle"></i>
                    <div>
                        <p class="notice-title">Motivo del rechazo</p>
                        <p>{{ request.rejectionReason }}</p>
                    </div>
                </div>

                <!-- Decisión: comentario + aprobar / rechazar -->
                <div class="decision" *ngIf="canApprove(request) || canReject(request)">
                    <label for="actionComments">
                        {{ showRejectMode ? 'Motivo del rechazo *' : 'Comentarios (opcional)' }}
                    </label>
                    <textarea
                        id="actionComments"
                        pInputTextarea
                        [(ngModel)]="actionComments"
                        rows="3"
                        class="w-full"
                        [placeholder]="showRejectMode ? 'Explica por qué se rechaza esta solicitud…' : 'Agrega comentarios adicionales…'"
                        [ngClass]="{ 'ng-invalid ng-dirty': showReasonError && showRejectMode }"
                    ></textarea>
                    <small class="p-error" *ngIf="showReasonError && showRejectMode">La razón del rechazo es obligatoria</small>
                    <small class="block mt-2 text-color-secondary" *ngIf="showRejectMode">
                        El colaborador recibirá el rechazo con el motivo que escribas.
                    </small>

                    <div class="decision-actions">
                        <ng-container *ngIf="!showRejectMode">
                            <p-button
                                *ngIf="canReject(request)"
                                label="Rechazar"
                                icon="pi pi-times"
                                styleClass="p-button-outlined p-button-danger"
                                [disabled]="linkExpired"
                                (onClick)="toggleRejectMode()"></p-button>
                            <p-button
                                *ngIf="canApprove(request)"
                                label="Aprobar"
                                icon="pi pi-check"
                                [loading]="processingAction"
                                [disabled]="linkExpired"
                                (onClick)="confirmApprove()"></p-button>
                        </ng-container>
                        <ng-container *ngIf="showRejectMode">
                            <p-button
                                label="Volver"
                                styleClass="p-button-text p-button-secondary"
                                (onClick)="toggleRejectMode()"></p-button>
                            <p-button
                                label="Confirmar rechazo"
                                icon="pi pi-times"
                                styleClass="p-button-danger"
                                [loading]="processingAction"
                                [disabled]="linkExpired"
                                (onClick)="confirmReject()"></p-button>
                        </ng-container>
                    </div>
                </div>
            </section>
        </ng-container>

        <footer class="public-footer">
            ¿Tienes dudas? Escríbenos a <a href="mailto:comunidad@avalanz.com">comunidad&#64;avalanz.com</a>.<br />
            Si tienes dudas sobre la solicitud, habla con el colaborador o con Capital Humano.
        </footer>
    </div>
</div>
